import type { ProductStatus } from "@eaub/shared";

/** Status chip for products: active (live on the storefront) vs archived (hidden). */
export function ProductStatusBadge({ status }: { status: ProductStatus }) {
  const className = status === "active" ? "badge badge--success" : "badge badge--muted";
  const label = status === "active" ? "Active" : "Archived";
  return <span className={className}>{label}</span>;
}
